module.exports = __webpack_public_path__ + "lp/img/icon_check.9bca2768.svg";